/*
  P4P Rx Request — keeps prescription items OUT of the Shopify cart.
  - Product pages: "Add to Rx Request" stores items in this browser's Rx list.
  - Cart page: shows the Rx list under "Prescription Items — not charged today",
    and moves any PRESCRIPTION item that reached the cart into the Rx list (backstop).
  - Checkout buttons: if the Rx list has items, send the customer to the Rx Request
    form first. OTC items check out normally afterwards.
  - Rx Request page: fills the hidden "Rx Items" field; clears the list after a successful submit.
  Rx payment happens only through a P4P-issued Draft Order invoice after approval.
*/
(function () {
  'use strict';

  var KEY = 'p4p-rx-request-v1';
  var REQUEST_URL = '/pages/request-form?view=rx-request';

  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function save(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    render();
  }

  function addItem(item) {
    var list = load();
    var existing = list.find(function (i) { return String(i.variantId) === String(item.variantId); });
    if (existing) {
      existing.qty = (parseInt(existing.qty, 10) || 1) + (parseInt(item.qty, 10) || 1);
    } else {
      list.push(item);
    }
    save(list);
  }

  function setQty(variantId, qty) {
    var list = load();
    qty = parseInt(qty, 10);
    list = list
      .map(function (i) {
        if (String(i.variantId) === String(variantId)) i.qty = qty;
        return i;
      })
      .filter(function (i) { return i.qty > 0; });
    save(list);
  }

  function money(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function itemLabel(i) {
    var v = i.variantTitle && i.variantTitle !== 'Default Title' ? ' — ' + i.variantTitle : '';
    return i.title + v;
  }

  /* ---------- Rendering (cart page + request page) ---------- */

  function render() {
    var list = load();
    document.documentElement.classList.toggle('rx-has-items', list.length > 0);

    document.querySelectorAll('[data-rx-list]').forEach(function (box) {
      var itemsEl = box.querySelector('[data-rx-items]');
      box.hidden = list.length === 0 && !box.hasAttribute('data-rx-always-show');
      if (!itemsEl) return;
      var editable = box.hasAttribute('data-rx-editable');
      if (list.length === 0) {
        itemsEl.innerHTML = '<p class="rx-empty">Your Prescription Request is empty.</p>';
        return;
      }
      itemsEl.innerHTML = list
        .map(function (i) {
          return (
            '<div class="rx-item">' +
            (i.image ? '<img class="rx-item__img" src="' + esc(i.image) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="rx-item__img"></span>') +
            '<div class="rx-item__info">' +
            '<a class="rx-item__title" href="' + esc(i.url) + '">' + esc(itemLabel(i)) + '</a>' +
            '<span class="rx-item__meta"><span class="rx-pill" aria-hidden="true">Rx</span> ' + esc(money(i.price)) + ' each · not charged today</span>' +
            '</div>' +
            (editable
              ? '<div class="rx-item__qty">' +
                '<button type="button" class="rx-qty-btn" data-rx-dec="' + esc(i.variantId) + '" aria-label="Decrease quantity">−</button>' +
                '<span class="rx-qty-val">' + esc(i.qty) + '</span>' +
                '<button type="button" class="rx-qty-btn" data-rx-inc="' + esc(i.variantId) + '" aria-label="Increase quantity">+</button>' +
                '<button type="button" class="rx-remove" data-rx-remove="' + esc(i.variantId) + '">Remove</button>' +
                '</div>'
              : '<span class="rx-item__qty">Qty ' + esc(i.qty) + '</span>') +
            '</div>'
          );
        })
        .join('');
    });

    var field = document.querySelector('[data-rx-items-field]');
    if (field) {
      field.value = list
        .map(function (i) {
          return itemLabel(i) + (i.sku ? ' [SKU ' + i.sku + ']' : '') + ' — Qty ' + i.qty + ' — ' + money(i.price) + ' each — Variant ID ' + i.variantId;
        })
        .join('\n');
    }
  }

  /* ---------- Product page: Add to Rx Request ---------- */

  function currentVariantId(box) {
    var sectionId = box.getAttribute('data-section-id');
    var info = document.querySelector('product-info[data-section="' + sectionId + '"]') || document;
    var selected = info.querySelector('variant-selects [data-selected-variant]');
    if (selected) {
      try {
        var v = JSON.parse(selected.textContent);
        if (v && v.id) return v.id;
      } catch (e) {}
    }
    var param = new URLSearchParams(window.location.search).get('variant');
    return param || box.getAttribute('data-default-variant-id');
  }

  function currentQty(box) {
    var formId = box.getAttribute('data-product-form-id');
    var input = document.querySelector('input[name="quantity"][form="' + formId + '"]');
    var q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  function onAdd(box) {
    var variants = [];
    try {
      variants = JSON.parse(box.querySelector('[data-rx-variants]').textContent);
    } catch (e) {}
    var id = currentVariantId(box);
    var v = variants.find(function (x) { return String(x.id) === String(id); }) || variants[0] || {};
    addItem({
      variantId: v.id || id,
      title: box.getAttribute('data-product-title'),
      variantTitle: v.title || '',
      sku: v.sku || '',
      price: v.price,
      qty: currentQty(box),
      url: box.getAttribute('data-product-url'),
      image: box.getAttribute('data-product-image') || ''
    });
    var msg = box.querySelector('[data-rx-added-msg]');
    if (msg) msg.hidden = false;
  }

  /* ---------- Cart backstop: move PRESCRIPTION lines out of the cart ---------- */

  function moveRxLinesOutOfCart() {
    var dataEl = document.querySelector('[data-rx-cart-lines]');
    if (!dataEl) return;
    var lines = [];
    try {
      lines = JSON.parse(dataEl.textContent);
    } catch (e) {}
    if (!lines.length) return;

    // Guard against a reload loop if the cart update ever fails.
    try {
      var last = parseInt(window.sessionStorage.getItem('p4p-rx-moving') || '0', 10);
      if (Date.now() - last < 15000) return;
      window.sessionStorage.setItem('p4p-rx-moving', String(Date.now()));
    } catch (e) {}

    var updates = {};
    lines.forEach(function (l) {
      addItem({
        variantId: l.variantId,
        title: l.title,
        variantTitle: l.variantTitle,
        sku: l.sku,
        price: l.price,
        qty: l.qty,
        url: l.url,
        image: l.image
      });
      updates[l.key] = 0;
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .catch(function () {})
      .then(function () {
        window.location.reload();
      });
  }

  /* ---------- Checkout gate ---------- */

  function isCheckoutTrigger(el) {
    if (!el) return false;
    var btn = el.closest('button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout, a[href$="/checkout"], a[href*="/checkout?"]');
    return !!btn;
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var add = t.closest && t.closest('[data-rx-add]');
      if (add) {
        e.preventDefault();
        onAdd(add.closest('[data-rx-buy-box]'));
        return;
      }
      var inc = t.closest && t.closest('[data-rx-inc]');
      var dec = t.closest && t.closest('[data-rx-dec]');
      var rem = t.closest && t.closest('[data-rx-remove]');
      if (inc || dec || rem) {
        var id = (inc || dec || rem).getAttribute(inc ? 'data-rx-inc' : dec ? 'data-rx-dec' : 'data-rx-remove');
        var item = load().find(function (i) { return String(i.variantId) === String(id); });
        if (!item) return;
        setQty(id, rem ? 0 : item.qty + (inc ? 1 : -1));
        return;
      }
      if (load().length > 0 && t.closest && isCheckoutTrigger(t) && !t.closest('[data-rx-allow-checkout]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = REQUEST_URL;
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var submitter = e.submitter;
      if (load().length > 0 && submitter && submitter.name === 'checkout' && !submitter.closest('[data-rx-allow-checkout]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = REQUEST_URL;
      }
    },
    true
  );

  /* ---------- Rx Request page ---------- */

  function initRequestPage() {
    var form = document.querySelector('[data-rx-request-form]');
    var posted = document.querySelector('[data-rx-request-posted]');
    if (posted) {
      save([]);
      return;
    }
    if (!form) return;

    var vetFields = form.querySelector('[data-rx-vet-fields]');
    function syncVet() {
      var picked = form.querySelector('input[name="contact[P4P VCPR client]"]:checked');
      var isP4P = picked && picked.value === 'Yes — P4P is my veterinarian';
      if (!vetFields) return;
      vetFields.hidden = !!isP4P;
      vetFields.querySelectorAll('[data-rx-vet-required]').forEach(function (inp) {
        inp.required = !isP4P;
      });
    }
    form.addEventListener('change', function (e) {
      if (e.target.name === 'contact[P4P VCPR client]') syncVet();
    });
    syncVet();

    form.addEventListener('submit', function (e) {
      render();
      if (load().length === 0) {
        e.preventDefault();
        var err = form.querySelector('[data-rx-empty-error]');
        if (err) err.hidden = false;
      }
    });
  }

  // The Rx Request page uses the alternate template page.rx-request via ?view=rx-request,
  // so the page works without assigning a template in admin. Keep the view after the
  // contact form redirects back with ?contact_posted=true.
  function keepRequestView() {
    var params = new URLSearchParams(window.location.search);
    if (/\/pages\/request-form\/?$/.test(window.location.pathname) && params.get('view') !== 'rx-request') {
      params.set('view', 'rx-request');
      window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
      return true;
    }
    return false;
  }

  function init() {
    if (keepRequestView()) return;
    render();
    moveRxLinesOutOfCart();
    initRequestPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) render();
  });
})();
